/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import './otherEfforts.scss';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../scopeDataGrid';
import ButtonComponent from '../../../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import deleteIcon from '../../../../../Assets/images/svg/dar_delete.svg';
import { TextField } from '@mui/material';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';
import UseAxios from '../../../../../Api/http/http';
import { useLocation } from 'react-router-dom';
import { otherEffortList, saveotherEffort, deleteotherEffort, editotherEffort } from '../../../../../Api/request/otherEfforts';
import { getTaskData } from '../../../../../Api/request/sdlc';
import SearchDropdown from '../../../../../Components/Dropdown/dropdown';
import { v4 as uuidv4 } from 'uuid';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';

const OtherEfforts = () => {
  const [searchText, setSearchText] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rows, setRows] = useState([]);
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };
  const [categories, setCategories] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const { snackbarOpen } = useSnackbar();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const DEAL_ID = parseInt(query.get('id'), 10);

  useEffect(() => {
    isMobileViewCheck();
    window.addEventListener('resize', isMobileViewCheck);
    return () => {
      window.removeEventListener('resize', isMobileViewCheck);
    };
  }, []);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [rows]);

  const fetchData = async () => {
    try {
      const taskDataResponse = await UseAxios(getTaskData());
      const taskData = taskDataResponse.data?.data || [];
      const formattedCategories = taskData.map(task => ({
        id: task.id,
        name: task.task
      }));
      setCategories(formattedCategories);

      const res = await UseAxios(otherEffortList(DEAL_ID));
      const resData = res.data?.data?.map((item, index) => ({
        id: item.id,
        srNo: index + 1,
        Category: formattedCategories.find((cat) => cat.id === item.category_id)?.name,
        Task: item.task,
        Details: item.details,
        inScope: item.in_scope,
        EstimatedEfforts: item.efforts,
        isEditing: false,
        isAdd: false,
      }));

      setRows(resData);
    } catch (err) {
      console.error('Error fetching data:', err);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };
  useEffect(() => {
    fetchData();
  }, [DEAL_ID]);

  const isMobileViewCheck = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  const handleSearchInput = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleAddRowGrid = () => {
    const newRow = {
      id: uuidv4(),
      srNo: rows.length + 1,
      checkbox: true,
      Category: '',
      Task: '',
      Details: '',
      EstimatedEfforts: 1,
      isEditing: true,
      isEdit: false,
      inScope: true,
      isAdd: true,
    };
    const updatedRows = [newRow, ...rows].map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));

    setRows(updatedRows);
  };

  const handleEditGrid = (id) => {
    setEditingRowId(id);
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, isEditing: true, isEdit: true, isAdd: false, originalData: { ...row } } : row))
    );
  };

  const handleSaveGrid = async (id) => {
    const rowToSave = rows.find((row) => row.id === id);
    const payload = {
      id: rowToSave.id,
      category_id: categories.find((cat) => cat.name === rowToSave.Category)?.id,
      task: rowToSave.Task || '',
      details: rowToSave.Details || '',
      in_scope: rowToSave.inScope || false,
      unit: 1,
      efforts: rowToSave.EstimatedEfforts || 0,
      deal_id: DEAL_ID,
    };

    if (rowToSave.isEdit) {
      try {
        await UseAxios(editotherEffort(payload));
        snackbarOpen('Data updated successfully', 'success');
      }
      catch (error) {
        console.error('Error saving row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;
      }
    }
    else {
      try {
        await UseAxios(saveotherEffort(payload));
        snackbarOpen('Data saved successfully', 'success');
      } catch (error) {
        console.error('Error saving row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;
      }
    }

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: false, isEdit: false, isAdd: false } : row
      )
    );
    fetchData();
    setEditingRowId(null);
  };

  const handleCancelGrid = (id) => {
    setEditingRowId(null);
    setRows((prevRows) =>
      prevRows.some((row) => row.isEdit)
        ? // If the row is in editing mode, restore the original data
        prevRows.map((row) =>
          row.id === id
            ? { ...row.originalData, isEditing: false, isEdit: false, isAdd: false }
            : row
        )
          .filter((row) => row.id) // Ensure all rows have an `id`
          .map((row, index) => ({
            ...row,
            srNo: index + 1,
          }))
        : // Otherwise, remove the row and reassign Sr. No
        prevRows
          .filter((row) => row.id !== id)
          .map((row, index) => ({
            ...row,
            srNo: index + 1, // Reassign Sr. No sequentially
          }))
    );
  };

  const handleDeleteGrid = async (id) => {
    try {
      const config = deleteotherEffort(id);
      await UseAxios(config);
      setRows((prevRows) =>
        prevRows
          .filter((row) => row.id !== id) // Remove the row
          .map((row, index) => ({ ...row, srNo: index + 1 })) // Reassign srNo sequentially
      );
      snackbarOpen('Data deleted successfully', 'success');
    } catch (error) {
      console.error('Error deleting effort:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  const filteredRowsGrid = searchText
    ? rows.filter((row) =>
      Object.values(row).some((value) =>
        (value ? value.toString() : '').toLowerCase().includes(searchText)
      )
    )
    : rows;

  const handleInputChange = (e, id, field, gridName) => {
    const value = field === 'inScope' ? e.target.checked : e.target.value?.name || e.target.value;
    if (gridName === 'rows') {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, [field]: value } : row
        )
      );
    }
  };

  const handleIncrement = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, EstimatedEfforts: row.EstimatedEfforts + 1 } : row
      )
    );
  };

  const handleDecrement = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, EstimatedEfforts: Math.max(row.EstimatedEfforts - 1, 1) } : row
      )
    );
  };

  const newRowTemplate = {
    Category: '',
    Task: '',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newRowTemplate).some((key) => row[key] === newRowTemplate[key]);
  };

  const getSelectedValue = (selectedName, options) => {
    return options.find(option => option.name === selectedName) || null;
  };

  const otherColumns = [
    {
      field: 'srNo',
      headerName: 'Sr.No.',
      width: 130,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'Category',
      headerName: 'Category',
      width: 160,
      minWidth: 185,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              placeholder='Select'
              options={categories}
              onChange={(e) => handleInputChange(e, params.row.id, 'Category', 'rows')}
              value={getSelectedValue(params.row.Category, categories)}
              dropdownCss="text-box-css"
            />
            {/* <div style={{ marginTop: 10, display: 'flex', gap: '10px' }}>
            <Button
              className="save-and-cancel-button"
              variant="contained"
              sx={{
                backgroundColor: '#6B5CE8 !important',
                color: 'white !important',
                '&.Mui-disabled': {
                  opacity: 0.4,
                }
              }}
              disabled={isRowUnchanged(params.row)}
              onClick={() => handleSaveGrid(params.row.id)}
            >
              Save
            </Button>
            <Button
              className="save-and-cancel-button"
              variant="outlined"
              style={{
                color: '#6B5CE8',
                borderColor: '#6B5CE8',
              }}
              onClick={() => handleCancelGrid(params.row.id)}
            >
              Cancel
            </Button>
          </div> */}
          </div>
        ) : (
          <label className="saved-value">{params.row.Category}</label>
        ),
    },
    {
      field: 'Task',
      headerName: 'Task',
      width: isMobileView ? 300 : undefined,
      flex: !isMobileView ? 0.75 : undefined,
      minWidth: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
            defaultValue={row.Task}
            onChange={(e) => handleInputChange(e, row.id, 'Task', "rows")}
            onKeyDown={(e) => e.stopPropagation()}
            className="task-details-css"
            variant="outlined"
            size="small"
            sx={{
              width: '100%',
              maxWidth: !isMobileView ? '320px' : '100%',
            }}
          />
        ) : (
          <label className="saved-value">{row.Task}</label>
        ),
    },

    {
      field: 'Details',
      headerName: 'Details',
      sortable: false,
      disableColumnMenu: true,
      width: isMobileView ? 300 : undefined,
      flex: !isMobileView ? 0.75 : undefined,
      minWidth: 135,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
            defaultValue={row.Details}
            onChange={(e) => handleInputChange(e, row.id, 'Details', "rows")}
            onKeyDown={(e) => e.stopPropagation()}
            className="task-details-css"
            variant="outlined"
            size="small"
            sx={{
              width: '100%',
              maxWidth: !isMobileView ? '320px' : '100%',
            }}
          />
        ) : (
          <label className="saved-value">{row.Details}</label>
        ),
    },
    {
      field: 'inScope',
      headerName: 'In Scope?',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <input
          disabled={!params.row.isEditing}
          type="checkbox"
          className="check-box-css"
          checked={params.row.inScope}
          onChange={(e) => handleInputChange(e, params.row.id, 'inScope', 'rows')}
          style={{
            marginLeft: 30,
          }}
        />
      ),
    },
    {
      field: 'EstimatedEfforts',
      headerName: 'Estimated Efforts (Days)',
      minWidth: 210,
      flex: 0.6,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className="increment-decrement-container">
            <button
              className="increment-decrement-button"
              onClick={() => handleDecrement(params.row.id)}
              id='decrement-button'
            >
              -
            </button>
            <input
              type="text"
              className="increment-decrement-input"
              value={params.row.EstimatedEfforts}
              onChange={(e) => handleInputChange(e, params.row.id, 'EstimatedEfforts', 'rows')}
            />
            <button
              className="increment-decrement-button"
              onClick={() => handleIncrement(params.row.id)}
              id='increment-button'
            >
              +
            </button>
          </div>
        ) : (
          <label className="saved-value">{params.row.EstimatedEfforts}</label>
        ),
    },
    {
      width: 100,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: (params) => (
        <div>
          {!params.row?.isEditing ? (
            <div className="mobile-action-icons">
              {editingRowId !== params.row.id && !params.row?.isAdd && (
                <button
                  className="role-action-edit-icon"
                  aria-label="Edit"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '10px',
                    cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
                    opacity: !hasAccess('update') ? 0.4 : 1,
                  }}
                  onClick={() => handleEditGrid(params.row.id)}
                  disabled={!hasAccess('update')}
                >
                  <img src={EditIcon} alt="Edit" />
                </button>
              )}
              {!params.row?.isAdd && (
                <button
                  className="role-action-delete-icon"
                  aria-label="Delete"
                  onClick={() => handleDeleteGrid(params.row.id)}
                  disabled={!hasAccess('delete')}
                >
                  <img src={deleteIcon} alt="Delete" />
                </button>
              )}
            </div>
          ) : (
            <div className="mobile-action-icons">
            <div className="save-and-cancel-button-main" style={{ paddingTop: '0px' }}>
              <button
                className='save-and-cancel-button save-button-tick-placing'
                style={{
                  backgroundColor: isRowUnchanged(params.row) ? '#a69df1' : '#6B5CE8',
                  color: '#ffff',
                }}
                disabled={isRowUnchanged(params.row)}
                onClick={() => handleSaveGrid(params.row.id)}
              >✔</button>
              <button
                className='save-and-cancel-button save-button-cross-placing'
                style={{
                  backgroundColor: 'transparent',
                  color: '#6B5CE8',
                  border: '1px solid #6B5CE8'
                }}
                onClick={() => handleCancelGrid(params.row.id)}
              >X</button>
            </div>
            </div>
          )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const sortFilterColumns = [
    otherColumns[0].field,
    otherColumns[1].field,
    otherColumns[2].field,
    otherColumns[3].field,
    otherColumns[4].field,
    otherColumns[5].field,
  ];

  return (
    <div className="other-effort-outer-layer">
      <div className="other-effort-map">
        <div
          className="other-effort-search-and-buttons"
          style={{ marginBottom: '20px' }}
        >
          <div className="other-effort-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="other-effort-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearchInput}
            />
          </div>
        </div>
        <div
          style={{
            border: '1px solid #ECE6EE',
            padding: '15px',
            backgroundColor: '#F1F5F8',
            marginBottom: '20px',
            borderRadius: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <div className="add-buttons">
              <ButtonComponent
                variant="contained"
                label="Add"
                onClick={handleAddRowGrid}
                startIcon={<AddIcon />}
                btnCss={`other-task-add-btn ${!hasAccess('create') ? 'disabled-btn' : ''}`}
                id="add-other-task-id"
                disabled={!hasAccess('create')}

              />
            </div>
          </div>
          <div className="data-grid-container">
            <DataGridComponent
              dataRows={filteredRowsGrid}
              dataColumns={otherColumns}
              pageSize={10}
              isFilteredRows={filteredRowsGrid}
              sortFilterColumns={sortFilterColumns}
              isEdit={isEdit}
              onRowSelectionChange={() => { }}
              dataGridCss=""
              checkboxDisabled={false}
              editStateHeight={110}
              NoDataImage={NoDataFound}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherEfforts;